import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-able",
  "use": "icon-able-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-able\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>icon24/able</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-able_icon24-symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-able_icon24/able\">\n            <circle id=\"icon-able_Oval\" fill=\"#DCFFE4\" cx=\"12\" cy=\"12\" r=\"9\" />\n            <circle id=\"icon-able_Oval\" fill=\"#18D2A3\" cx=\"12\" cy=\"12\" r=\"8\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/able.svg
// module id = 4B0f
// module chunks = 54